import React, { useState, useEffect } from 'react';
import { 
  CreditCard, 
  DollarSign, 
  CheckCircle, 
  Tag,
  ArrowLeft,
  ArrowRight,
  Loader2,
  Zap,
  Shield,
  Clock,
  RefreshCw,
  X // <-- Agregar este ícono
} from 'lucide-react';

function Payment({ onNavigateBack }) {
  console.log('Payment.js: COMPONENTE MONTANDO');
  
  const [loading, setLoading] = useState(false);
  const [trialCode, setTrialCode] = useState('');
  const [trialApplied, setTrialApplied] = useState(null);
  const [validatingTrial, setValidatingTrial] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [registroData, setRegistroData] = useState(null);
  const [showCheck, setShowCheck] = useState(false);

  const basePrice = 10000; // Para mostrar en UI
  const realPaymentAmount = 50; // Para el monto real de pago
  
  const trialCodes = {
    '1MESGRATIS': { type: 'trial', value: 30, description: '1 MES GRATIS' }
  };

  useEffect(() => {
    console.log('Payment.js: useEffect 1 - Resize listener');
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => {
      console.log('Payment.js: useEffect 1 - Cleanup resize listener');
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    console.log('Payment.js: useEffect 2 - Leyendo sessionStorage');
    const datos = sessionStorage.getItem('registro_constructora');
    console.log('Payment.js: datos en sessionStorage:', datos);
    if (!datos) {
      console.log('Payment.js: No hay datos en sessionStorage, setRegistroData(null)');
      setRegistroData(null);
      return;
    }
    console.log('Payment.js: Datos encontrados, parseando JSON');
    setRegistroData(JSON.parse(datos));
  }, []);

  const calculateFinalPrice = () => {
    // Con prueba gratuita de 14 días, siempre mostramos el precio completo
    // MercadoPago maneja automáticamente la prueba gratuita
    return basePrice;
  };

  const handleTrialValidation = () => {
    const code = trialCode.trim().toUpperCase();
    if (!code) return;

    setValidatingTrial(true);
    setShowCheck(false);

    setTimeout(() => {
      if (trialCodes[code]) {
        setTrialApplied(trialCodes[code]);
        if (isMobile) {
          setShowCheck(true);
          setTimeout(() => setShowCheck(false), 1200);
        }
      } else {
        alert('Código no válido');
        setTrialCode('');
      }
      setValidatingTrial(false);
    }, 800);
  };

  const removeTrial = () => {
    setTrialApplied(null);
    setTrialCode('');
  };

  const handlePayment = async () => {
    setLoading(true);
    try {
      if (!registroData) {
        alert('Faltan datos del registro.');
        return;
      }
      // Usar los datos completos del registro para crear la preferencia
      const subscriptionData = {
        reason: 'Suscripción Plan Constructora Pro',
        auto_recurring: {
          frequency: 1,
          frequency_type: 'months',
          transaction_amount: realPaymentAmount,
          currency_id: 'ARS'
        },
        back_url: 'https://nokk.com.ar/onboarding',
        payer_email: registroData.email_empleado || 'cliente@constructora.com',
        metadata: {
          ...registroData,
          pre_registro_id: registroData.pre_registro_id // Asegura que el id esté en metadata
        }
      };
      console.log('🚀 Creando suscripción automática:', subscriptionData);
      // Llamada al backend para crear la suscripción
      const response = await fetch('https://nokk-backend.vercel.app/api/create-subscription', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(subscriptionData)
      });
      const result = await response.json();
      if (!result.success) {
        throw new Error(result.error || 'Error creando suscripción');
      }
      // Redirigir a MercadoPago usando el init_point
      window.location.href = result.init_point;
    } catch (error) {
      console.error('Error en suscripción:', error);
      alert('Error en suscripción: ' + error.message);
    }
    setLoading(false);
  };

  const finalPrice = calculateFinalPrice();
  const hasFreeTrial = trialApplied !== null;
  const trialDays = trialApplied ? trialApplied.value : 0;

  console.log('Payment.js: RENDERIZANDO - registroData:', registroData);

  if (!registroData) {
    console.log('Payment.js: No hay registroData, mostrando pantalla de error');
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <Loader2 className="animate-spin" size={48} />
        <h2 style={{ marginTop: 20 }}>No se encontraron datos de registro.<br/>Por favor, completá el registro antes de pagar.</h2>
        <button onClick={() => window.location.href = '/registro-constructora'} style={{marginTop: 20, padding: '10px 20px', borderRadius: 8, border: 'none', background: '#059669', color: 'white', fontWeight: 600, fontSize: 16, cursor: 'pointer'}}>Ir al registro</button>
      </div>
    );
  }

  console.log('Payment.js: Renderizando pantalla de pago completa');

  return (
    <>
      {/* Estilos CSS */}
      <style jsx global>{`
        input,
        select,
        textarea,
        button {
          font-size: 16px !important;
          -webkit-text-size-adjust: none;
          -webkit-appearance: none;
          -webkit-border-radius: 0;
          touch-action: manipulation;
        }

        @supports (-webkit-touch-callout: none) {
          .payment-container {
            min-height: -webkit-fill-available;
          }
        }

        body {
          -webkit-text-size-adjust: 100%;
          -webkit-touch-callout: none;
          -webkit-user-select: none;
          user-select: none;
          touch-action: manipulation;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.7;
          }
        }

        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        .animate-spin {
          animation: spin 1s linear infinite;
        }

        .fade-in-up {
          animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .nav-button-back:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
          border-color: #cbd5e1;
        }

        .nav-button-back:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .nav-button-pay:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4);
        }

        .nav-button-pay:active {
          transform: translateY(0);
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
        }

        .nav-button-pay:disabled:hover {
          transform: none;
          box-shadow: 0 4px 12px rgba(148, 163, 184, 0.3);
        }

        .payment-pulse {
          animation: pulse 2s infinite;
        }

        .payment-pulse:hover {
          animation: none;
        }

        @keyframes glow {
          0%, 100% {
            text-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
          }
          50% {
            text-shadow: 0 0 15px rgba(255, 255, 255, 0.8), 0 0 25px rgba(255, 255, 255, 0.4);
          }
        }

        .payment-glow {
          animation: glow 2s ease-in-out infinite;
        }
      `}</style>

      {/* Container principal */}
      <div
        className="payment-container"
        style={{
          height: "100vh",
          height: "100dvh",
          background: isMobile
            ? "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 50%, #e2e8f0 100%)"
            : "linear-gradient(135deg, #fafbfc 0%, #f1f5f9 25%, #e2e8f0 50%, #cbd5e1 75%, #94a3b8 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: isMobile ? "20px 16px" : "20px 24px",
          position: "relative",
          overflow: "hidden",
          fontFamily: '"Inter", sans-serif',
        }}
      >
        {/* Efectos de fondo */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: isMobile
              ? `
                radial-gradient(circle at 30% 20%, rgba(59, 130, 246, 0.05) 0%, transparent 50%),
                radial-gradient(circle at 70% 80%, rgba(16, 185, 129, 0.05) 0%, transparent 50%)
              `
              : `
                radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.05) 0%, transparent 50%),
                radial-gradient(circle at 80% 20%, rgba(16, 185, 129, 0.05) 0%, transparent 50%),
                radial-gradient(circle at 40% 40%, rgba(139, 92, 246, 0.05) 0%, transparent 50%)
              `,
            pointerEvents: "none",
          }}
        />

        {/* Card principal */}
        <div
          className="fade-in-up"
          style={{
            background: isMobile
              ? "rgba(255, 255, 255, 0.98)"
              : "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(20px)",
            borderRadius: "24px",
            padding: isMobile ? "24px 20px 20px 20px" : "24px 24px",
            width: "100%",
            maxWidth: isMobile ? "400px" : "500px",
            height: isMobile ? "auto" : "520px",
            minHeight: isMobile ? "520px" : "520px",
            maxHeight: isMobile ? "85vh" : "520px",
            boxShadow: isMobile
              ? "0 20px 60px -12px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(255, 255, 255, 0.1)"
              : "0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.05)",
            position: "relative",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            style={{
              textAlign: "center",
              marginBottom: isMobile ? "20px" : "12px",
              flexShrink: 0,
            }}
          >
            <div
              style={{
                marginBottom: isMobile ? "10px" : "4px",
              }}
            >
              <img
                src="https://llohruvkcdcyolmwlivx.supabase.co/storage/v1/object/public/public-assets//logonokk.png"
                alt="NOKK"
                style={{
                  height: isMobile ? "28px" : "24px",
                  width: "auto",
                  opacity: 0.9,
                }}
              />
            </div>

            <p
              style={{
                fontSize: isMobile ? "13px" : "11px",
                color: "#64748b",
                margin: isMobile ? "0" : "0 0 8px 0",
                fontWeight: "400",
              }}
            >
              Plan Constructora Pro
            </p>
          </div>

          {/* Content area */}
          <div
            style={{
              flex: 1,
              overflow: "hidden",
              position: "relative",
              marginBottom: isMobile ? "24px" : "12px",
            }}
          >
            <div
              style={{
                overflowY: isMobile ? "auto" : "visible",
                maxHeight: isMobile ? "60vh" : "none",
                minHeight: isMobile ? "320px" : undefined,
                paddingBottom: isMobile ? "16px" : undefined,
                WebkitOverflowScrolling: isMobile ? "touch" : undefined,
              }}
            >
            
            {/* Plan features */}
            <div
              style={{
                background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                padding: "16px",
                borderRadius: "12px",
                border: "1px solid #e2e8f0",
                marginBottom: "16px",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "12px" }}>
                <div>
                  <h4 style={{ margin: "0 0 2px 0", fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>
                    Acceso completo
                  </h4>
                  <p style={{ margin: 0, fontSize: "12px", color: "#64748b" }}>
                    Todo lo que necesitás para gestionar tu constructora
                  </p>
                </div>
                <div style={{ textAlign: "right" }}>
                  {/* Emoji eliminado, display profesional */}
                  {hasFreeTrial && (
                    <div style={{ fontSize: "10px", color: "#16a34a", marginBottom: "2px", fontWeight: "500", letterSpacing: 1 }}>
                      1MESGRATIS
                    </div>
                  )}
                  <div style={{ fontSize: "22px", fontWeight: "800", color: "#059669", lineHeight: 1 }}>
                    ${finalPrice.toLocaleString()}
                  </div>
                  <div style={{ fontSize: "11px", color: "#64748b", lineHeight: 1 }}>
                    ARS/mes{hasFreeTrial ? " (después del trial)" : ""}
                  </div>
                </div>
              </div>
              
              <div style={{ fontSize: "11px", color: "#64748b", lineHeight: "1.4" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "4px" }}>
                  <CheckCircle size={12} color="#059669" />
                  Usuarios ilimitados
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "4px" }}>
                  <CheckCircle size={12} color="#059669" />
                  Proyectos ilimitados
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "4px" }}>
                  <CheckCircle size={12} color="#059669" />
                  Gestión completa de presupuestos
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <CheckCircle size={12} color="#059669" />
                  Soporte técnico incluido
                </div>
              </div>
            </div>

            {/* Discount section */}
            <div
              style={{
                background: "#f8fafc",
                padding: "16px",
                borderRadius: "12px",
                border: "1px solid #e2e8f0",
                marginBottom: isMobile ? "16px" : "8px",
              }}
            >
              <h4
                style={{
                  margin: "0 0 12px 0",
                  fontSize: "13px",
                  fontWeight: "600",
                  color: "#1e293b",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <Tag size={16} color="#3b82f6" />
                Código de prueba gratuita
              </h4>

              {!trialApplied ? (
                <div style={{ display: "flex", gap: "8px" }}>
                  <input
                    type="text"
                    value={trialCode}
                    onChange={(e) => setTrialCode(e.target.value.toUpperCase())}
                    placeholder={isMobile ? "Código 1MESGRATIS" : "Ingresá tu código para 1MESGRATIS"}
                    style={{
                      flex: 1,
                      padding: "10px 12px",
                      border: "2px solid #f1f5f9",
                      borderRadius: "8px",
                      fontSize: isMobile ? "12px" : "13px",
                      outline: "none",
                      background: "#fafafa",
                      transition: "all 0.2s ease",
                    }}
                    onKeyPress={(e) => e.key === 'Enter' && handleTrialValidation()}
                  />
                  <button
                    onClick={handleTrialValidation}
                    disabled={!trialCode.trim() || validatingTrial}
                    style={{
                      padding: isMobile ? "10px 12px" : "10px 16px",
                      background: validatingTrial ? "#94a3b8" : "#3b82f6",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      fontSize: isMobile ? "12px" : "13px",
                      fontWeight: "600",
                      cursor: validatingTrial ? "not-allowed" : "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: isMobile ? "0" : "4px",
                      minWidth: isMobile ? "40px" : "auto",
                      transition: "background 0.2s",
                    }}
                  >
                    {isMobile ? (
                      validatingTrial ? (
                        <Loader2 size={16} className="animate-spin" />
                      ) : showCheck ? (
                        <CheckCircle size={16} color="#22c55e" />
                      ) : (
                        <CheckCircle size={16} />
                      )
                    ) : (
                      <>
                        {validatingTrial && <Loader2 size={14} className="animate-spin" />}
                        Aplicar
                      </>
                    )}
                  </button>
                </div>
              ) : (
                <div
                  style={{
                    background: "#f8fafc",
                    padding: "12px",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <CheckCircle size={16} color="#059669" />
                    <div>
                      <div style={{ fontSize: "13px", fontWeight: "500", color: "#1e293b" }}>
                        Código aplicado
                      </div>
                      <div style={{ fontSize: "11px", color: "#64748b" }}>
                        {trialApplied.description} • Después ${basePrice.toLocaleString()}/mes
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={removeTrial}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#64748b",
                      cursor: "pointer",
                      padding: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <X size={14} />
                  </button>
                </div>
              )}
            </div>

            {/* Payment summary */}
            <div
              style={{
                background: "#f8fafc",
                padding: "16px",
                borderRadius: "12px",
                border: "1px solid #e2e8f0",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                <span style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b" }}>
                  {hasFreeTrial ? "Precio mensual después del trial:" : "Precio mensual:"}
                </span>
                <span style={{ fontSize: "20px", fontWeight: "700", color: "#1e293b" }}>
                  ${finalPrice.toLocaleString()}
                </span>
              </div>
              
              {hasFreeTrial && (
                <div style={{ fontSize: "12px", color: "#64748b", textAlign: "center" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                    <Clock size={14} />
                    Primer mes gratuito
                  </div>
                  <div style={{ fontSize: "11px", marginTop: "2px", opacity: 0.8 }}>
                    Renovación automática mensual después del trial
                  </div>
                </div>
              )}
              
              {!hasFreeTrial && (
                <div style={{ fontSize: "11px", color: "#64748b", textAlign: "center", marginTop: "4px", display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                  <RefreshCw size={14} style={{ opacity: 0.7 }} />
                  Suscripción automática mensual
                </div>
              )}
            </div>
          </div>
        </div>

          {/* Navigation buttons */}
          <div
            style={{
              display: "flex",
              gap: isMobile ? "14px" : "12px",
              justifyContent: "space-between",
              flexShrink: 0,
              paddingTop: isMobile ? "12px" : "0",
              paddingBottom: isMobile ? "16px" : "0",
              borderTop: isMobile ? "1px solid #f1f5f9" : "none",
              height: isMobile ? "52px" : "auto",
              alignItems: "center",
            }}
          >
            <button
              onClick={onNavigateBack}
              className="nav-button-back"
              style={{
                flex: "1 1 0%",
                padding: isMobile ? "0 20px" : "14px 20px",
                background: "transparent",
                border: "1px solid #d4d4d4",
                borderRadius: isMobile ? "12px" : "10px",
                color: "#374151",
                fontSize: isMobile ? "14px" : "13px",
                fontWeight: "500",
                cursor: "pointer",
                transition: "all 0.2s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                position: "relative",
                overflow: "hidden",
                boxShadow: "none",
                height: isMobile ? "52px" : "auto",
                minWidth: "0",
                maxWidth: "none",
              }}
            >
              <ArrowLeft size={16} />
              Volver
            </button>

            <button
              onClick={handlePayment}
              disabled={loading}
              className="nav-button-pay"
              style={{
                flex: "1 1 0%",
                padding: isMobile ? "0 20px" : "14px 20px",
                background: loading ? "#94a3b8" : "#1a1a1a",
                color: "white",
                border: "none",
                borderRadius: isMobile ? "12px" : "10px",
                fontSize: isMobile ? "14px" : "13px",
                fontWeight: "500",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.2s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                position: "relative",
                overflow: "hidden",
                boxShadow: "none",
                height: isMobile ? "52px" : "auto",
                minWidth: "0",
                maxWidth: "none",
              }}
            >
              {loading && <Loader2 size={16} className="animate-spin" />}
              <span>
                {loading ? "Procesando..." : "Activar Suscripción"}
              </span>
              {!loading && <CreditCard size={16} />}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Payment;
